import ProductItem from "./default";
export default ProductItem;
